/**
 * STATION API
 * Namespace: STATION
 */

export const StationApi = {
    station: [
      {
        name: 'keywordSearch',
        method: 'POST',
        path: '/api/realbus/notAuthor/search/v1/keyword',
        mockPath: '/api/realbus/notAuthor/search/v1/keyword',
        params: {},
        desc: '2.4 模糊查找线路站点信息'
      },
      {
        name: 'nearStation',
        method: 'POST',
        path: '/api/realbus/notAuthor/line/station/v1/nearby',
        mockPath: '/api/realbus/notAuthor/line/station/v1/nearby',
        params: {},
        desc: '3.1 首页附近站点查询'
      },
      {
        name: 'mapStation',
        method: 'POST',
        path: '/api/realbus/notAuthor/line/map/v1/nearby',
        mockPath: '/api/realbus/notAuthor/line/map/v1/nearby',
        params: {},
        desc: '3.2 地图附近站点查询'
      },
      {
        name: 'findLineByStation',
        method: 'POST',
        path: '/api/realbus/notAuthor/line/station/v1/findLineByStation',
        mockPath: '/api/realbus/notAuthor/line/station/v1/findLineByStation',
        params: {},
        desc: '3.3 查询站牌下的线路'
      },
      {
        name: 'timetable',
        method: 'POST',
        path: '/api/realbus/notAuthor/line/bus/v1/timetable',
        mockPath: '/api/realbus/notAuthor/line/bus/v1/timetable',
        params: {},
        desc: '3.4 获取多条线路的最近两车辆或发车时刻'
      },
      {
        name: 'lineBasicInfo',
        method: 'POST',
        path: '/api/realbus/notAuthor/line/basic/v1/info',
        mockPath: '/api/realbus/notAuthor/line/basic/v1/info',
        params: {},
        desc: '3.5 获取线路的基础数据'
      },
      {
        name: 'busPosition',
        method: 'POST',
        path: '/api/realbus/notAuthor/line/bus/v1/position',
        mockPath: '/api/realbus/notAuthor/line/bus/v1/position',
        params: {},
        desc: '3.6 线路上车辆运行位置'
      },
      {
        name: 'stationInfo',
        method: 'POST',
        path: '/api/realbus/notAuthor/line/basic/v1/stationInfo',
        mockPath: '/api/realbus/notAuthor/line/basic/v1/stationInfo',
        params: {},
        desc: '3.8 获取线路站点信息'
      },
      {
        name: 'lineAllBus',
        method: 'POST',
        path: '/api/realbus/notAuthor/line/bus/v1/lineAllBus',
        mockPath: '/api/realbus/notAuthor/line/bus/v1/lineAllBus',
        params: {},
        desc: '4.2 获取线路上下行所有车辆信息'
      },
      {
        name: 'nearLine',
        method: 'POST',
        path: '/api/realbus/notAuthor/search/v1/line',
        mockPath: '/api/realbus/notAuthor/search/v1/line',
        params: {},
        desc: '2.2 精确查找线路'
      }
    ]
  }
  